export default {"src":"/pro/_next/static/media/icp.ce1a3d18.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};